import {dataManageService} from '@/service/httpService'

const actions = {
  editData ({commit}, param) {
    return dataManageService.editData(param)
  },
  delData ({commit}, param) {
    return dataManageService.delData(param)
  },
  loadListData ({commit}, param) {
    return dataManageService.loadListData(param)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/modules/data-edit/actions.js